import { ResponseType } from "../../Types/ServicesType/servicesType";
import {
  CptGroupwiseResultType,
  DailyRevenueReportType,
  DoctorWiseBillingReportType,
  EncounterWiseCollectionReportType,
  MonthlyRevenueReportType,
  ParamsType,
} from "./types";
import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import instance from "@services/services";
const {clinicId} = getConstants()
const { reportsApi } = api;

export const dailyInvoiceReportSearch = async (
  params: ParamsType
): Promise<ResponseType<DailyRevenueReportType[]>> => {
  const response = await instance.post(`${reportsApi.dailyInvoiveReport}`, {
    ...params,
    clinicId,
  });
  return response.data;
};

export const dailyInvoiceReportPdf = async (
  params: ParamsType
): Promise<ResponseType<string>> => {
  const response = await instance.post(`${reportsApi.dailyInvoiveReportPdf}`, {
    ...params,
    clinicId,
  });
  return response.data;
};

export const dailyInvoiceReportExcel = async (
  params: ParamsType
): Promise<ResponseType<string | null>> => {
  const response = await instance.post(
    `${reportsApi.dailyRevenueReportExcel}`,
    { ...params, clinicId }
  );
  return response.data;
};

export const monthltInvoiceReportSearch = async (params: {
  fromMonth: number;
  toMonth: number;
  fromYear: number;
  toYear: number;
}): Promise<ResponseType<MonthlyRevenueReportType[]>> => {
  const response = await instance.post(`${reportsApi.monthlyInvoiveReport}`, {
    ...params,
    clinicId,
  });
  return response.data;
};

export const monthlyInvoiceReportPdf = async (params: {
  fromMonth: number;
  toMonth: number;
  fromYear: number;
  toYear: number;
}): Promise<ResponseType<string>> => {
  const response = await instance.post(
    `${reportsApi.monthlyInvoiveReportPdf}`,
    {
      ...params,
      clinicId,
    }
  );
  return response.data;
};

export const doctorWiseBillingReport = async (params: ParamsType): Promise<ResponseType<DoctorWiseBillingReportType[]>> => {
  const response = await instance.post(
    `${reportsApi.doctorWiseBillingReport}`,
    {
      ...params,
      clinicId,
    }
  );
  return response.data;
};

export const doctorWiseBillingReportPdf = async (params: ParamsType): Promise<ResponseType<string>> => {
  const response = await instance.post(
    `${reportsApi.doctorWiseBillingReportPdf}`,
    {
      ...params,
      clinicId,
    }
  );
  return response.data;
};

export const encounterWiseCollectionSearch = async (
  params: ParamsType
): Promise<ResponseType<EncounterWiseCollectionReportType[]>> => {
  const response = await instance.post(`${reportsApi.encounterWiseCollection}`, {
    ...params,
    clinicId,
  });
  return response.data;
};

export const encounterWiseCollectionReportPdf = async (
  params: ParamsType
): Promise<ResponseType<string>> => {
  const response = await instance.post(`${reportsApi.encounterWiseCollectionPdf}`, {
    ...params,
    clinicId,
  });
  return response.data;
};

export const encounterWiseCollectionReportExcel = async (
  params: ParamsType
): Promise<ResponseType<string | null>> => {
  const response = await instance.post(
    `${reportsApi.encounterWiseCollectionExcel}`,
    { ...params, clinicId }
  );
  return response.data;
};

export const getCptwiseReport = async (params: ParamsType): Promise<ResponseType<CptGroupwiseResultType[]>>=>{
  const response = await instance.post(
    `${reportsApi.cptgroupwisereportdetails}`,
    { ...params, clinicId }
  );
  return response.data;
}

export const getCptwiseReportPdf = async (params: ParamsType): Promise<ResponseType<string>>=>{
  const response = await instance.post(
    `${reportsApi.cptgroupwisereportdetailspdf}`,
    { ...params, clinicId }
  );
  return response.data;
}